import { render, staticRenderFns } from "./ElTableColumnClientStatus.vue?vue&type=template&id=71545c7e"
import script from "./ElTableColumnClientStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElTableColumnClientStatus.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports